import React from 'react';
import Icon from "../../../../../core-components/IconsSelector";
import * as S from './SvgIconStyles';

const SvgIconElementUI = ({ iconName, iconWidth, iconHeight="auto", margin="auto" }) => {
    return (
        <S.IconWrapper
            iconWidth={iconWidth}
            iconHeight={iconHeight}
            margin={margin}
        >
            <Icon name={iconName} />
        </S.IconWrapper>
    )
}

export default SvgIconElementUI;
